const from = 'A'.charCodeAt(0);
const to = 'Z'.charCodeAt(0);
const distance = to - from + 1;

const columnIndexToName = columnIndex => {
  let letters = '';
  let colIndex = columnIndex;
  while (colIndex >= 0) {
    letters = String.fromCharCode(from + colIndex % distance) + letters;
    colIndex = Math.floor(colIndex / distance) - 1;
  }
  return letters;
};

export default columnIndexToName;
